;(function ($, window, document) {
    /* ------------------------------------------- */
    /* US MAP */
    /* ------------------------------------------- */
    const usStatesMap = $('#af-us-map');

    if (usStatesMap.length) {
        const mapColors = {
            default: usStatesMap.css('--map-default'),
            licensed: usStatesMap.css('--map-licensed'),
            unlicensed: usStatesMap.css('--map-unlicensed')
        };

        const licensedStates = usStatesMap[0].dataset.states
        const activeStates   = licensedStates ? JSON.parse(licensedStates) : {};
        const labelByState   = {};

        const map = new Datamap({
            element: usStatesMap[0],
            scope: 'usa',
            responsive: true,
            geographyConfig: {
                highlightOnHover: false,
            },
            fills: {
                defaultFill: mapColors.default,
            },
            done: function(datamap) {
                const svg            = datamap.svg;
                const stateTimeouts  = {}; // enable canceling delayed color changes on quick hovers
                const labelTimeouts  = {};
                const rippleDuration = 700; // keep it consistent

                datamap.labels({ labelColor: mapColors.default });

                svg.selectAll('.labels text').each(function() {
                    const el = d3.select(this);
                    labelByState[el.text()] = el;
                });

                // offset labels too close to state borders
                labelByState['HI']?.attr('dx', -5).classed('dark', true);
                labelByState['LA']?.attr('dx', -5);
                labelByState['FL']?.attr('dx', 5);

                // layer order matters: base -> hover -> borders -> labels
                const hoverLayer   = svg.insert('g', 'g.labels').attr('class', 'hover-layer');
                const bordersLayer = svg.insert('g', 'g.labels').attr('class', 'borders-layer');

                // create defs container for state clipPaths
                let defs = svg.select('defs');
                if (defs.empty()) defs = svg.append('defs');

                svg.selectAll('.datamaps-subunit').each(function() {
                    const geo = this.__data__;

                    defs.append('clipPath')
                        .attr('id', `clip-${geo.id}`)
                        .append(() => this.cloneNode());

                    bordersLayer.append(() => this.cloneNode());
                });

                svg.selectAll('.datamaps-subunit')
                    .on('mouseover', function(geo) {
                        const el         = d3.select(this);
                        const mouse      = d3.mouse(datamap.svg.node());
                        const isLicensed = activeStates.hasOwnProperty(geo.id);
                        const hoverColor = isLicensed ? mapColors.licensed : mapColors.unlicensed;
                        const labelColor = isLicensed ? mapColors.unlicensed : mapColors.licensed;

                        /* labels */
                        // cancel hiding label
                        clearTimeout(labelTimeouts[geo.id]);
                        delete labelTimeouts[geo.id];

                        // show the label
                        labelByState[geo.id]?.classed('active', true).style('fill', labelColor);

                        /* hover ripple effect */
                        // clear active mouseout ripples
                        hoverLayer.selectAll(`.ripple-${geo.id}`)
                            .interrupt('ripple').remove();

                        // add mouseover ripple
                        hoverLayer.append('circle').style('fill', hoverColor)
                            .attr('cx', mouse[0])
                            .attr('cy', mouse[1])
                            .attr('r', 0)
                            .attr('clip-path', `url(#clip-${geo.id})`)
                            .attr('class', `ripple-${geo.id}`)
                            .transition().duration(rippleDuration).ease('cubic-out').attr('r', 500).remove();

                        // update fill color after ripple expands
                        stateTimeouts[geo.id] = setTimeout(function() {
                            el.style('fill', hoverColor);
                        }, rippleDuration);
                    })
                    .on('mouseout', function(geo) {
                        const el         = d3.select(this);
                        const mouse      = d3.mouse(datamap.svg.node());
                        const isLicensed = activeStates.hasOwnProperty(geo.id);
                        const hoverColor = isLicensed ? mapColors.licensed : mapColors.unlicensed;

                        // hide the label after ripple effect starts
                        labelTimeouts[geo.id] = setTimeout(function() {
                            labelByState[geo.id]?.classed('active', false);
                        }, rippleDuration / 1.75); // hide approximately mid ripple

                        /* hover ripple effect */
                        // clear active mouseover ripples
                        hoverLayer.selectAll(`.ripple-${geo.id}`)
                            .interrupt('ripple').remove();

                        // add mouseout ripple
                        hoverLayer.append('circle').style('fill', hoverColor)
                            .attr('cx', mouse[0])
                            .attr('cy', mouse[1])
                            .attr('r', 500)
                            .attr('clip-path', `url(#clip-${geo.id})`)
                            .attr('class', `ripple-${geo.id}`)
                            .transition().duration(rippleDuration).ease('cubic-out').attr('r', 0).remove();

                        // clear mouseover fill change and reset fill color
                        clearTimeout(stateTimeouts[geo.id]);
                        delete stateTimeouts[geo.id];
                        el.style('fill', mapColors.default);
                    }).on('click', function(geo) {
                        const isLicensed = activeStates.hasOwnProperty(geo.id);
                        const event = d3.event

                        if (isLicensed) {
                            const slug = activeStates[geo.id];
                            const url  = '/states/' + slug;

                            if (slug) {
                                if (event.ctrlKey || event.metaKey) {
                                    const a  = document.createElement('a');
                                    a.href   = url;
                                    a.target = '_blank';
                                    a.rel    = 'noopener';

                                    document.body.appendChild(a);
                                    a.click();
                                    document.body.removeChild(a);
                                } else {
                                    window.location.href = url;
                                }
                            }
                        } else {
                            $('#map-popup').removeClass('pop-up-hide');
                            $('#map-popup').addClass('af-popup--active');
                        }
                    });
            }
        });

        let resizeTimer;
        d3.select(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                map.resize();
            }, 100);
        });
    }
})(jQuery, window, document);
